export default __webpack_public_path__ + "static/media/Tick-black.53a8fce1.svg";